"use strict";

var moment = require('moment-business-days');

var traverseDecisionTree = require('../../util/traverseDecisionTree');

function calculatePrintByDate(order, decisionTree) {
  var today = moment();
  var days_to_print = traverseDecisionTree(order, decisionTree);

  if (today.format('dddd') === 'Saturday' || today.format('dddd') === 'Sunday') {
    // add an extra day if today is Saturday or Sunday
    days_to_print += 1;
  } else if (order.printing_type.match(/1 DAY/) && today.tz('America/New_York').hours() >= 13 || today.tz('America/New_York').hours() >= 17) {
    days_to_print += 1;
  }

  var print_by_date = today.businessAdd(days_to_print, 'days');
  return print_by_date.hour(17).minute(0).second(0).millisecond(0);
}

module.exports = calculatePrintByDate;